import { useEffect } from 'react';
import { useRouter } from 'next/router';

import { useGetGroup, useGetGroupEvents } from 'legacy/groups/hooks';

function useOrganizationEvents() {
  const router = useRouter();
  const {
    data: events,
    isLoading,
    refetch
  } = useGetGroupEvents({
    groupId: router.query.organizationId as string,
    includeDrafts: true
  });

  const { data: organization, isLoading: isLoadingOrganization } = useGetGroup({
    groupId: router.query.organizationId as string
  });

  useEffect(() => {
    refetch();
  }, []);

  return {
    data: {
      events,
      isLoading: isLoadingOrganization || isLoading,
      organization
    }
  };
}

export default useOrganizationEvents;
